<template>
  <div class="detail">
    <div class="flex-sb-center detail_title">
      <div class="">Enquiry Details</div>
      <v-button
        gray
        @click="handleEidt">Edit Enquiry</v-button>
    </div>
    <div class="table">
      <div class="th">
        Enquiry
      </div>
      <div class="tr">
        <span>Type</span>
        <span>{{form.enquiry_type_language}}</span>
      </div>
      <div class="tr">
        <span>Submitted by</span>
        <span>{{form.submitted_by}}</span>
      </div>
      <div
        v-if="enquiry_type==10&&!isFina"
        class="tr">
        <span>Product Type</span>
        <span>{{form.product_type_language}}</span>
      </div>
      <template v-if="[20,30,40].includes(enquiry_type)">
        <div
          class="tr">
          <span>Insurer</span>
          <span>{{form.insurer}}</span>
        </div>
        <div class="tr">
          <span>Policy Number</span>
          <span>{{form.pcy_no}} </span>
        </div>
      </template>
    </div>
    <div
      v-if="![20,30,40].includes(form.enquiry_type)"
      class="table">
      <div class="th">
        Account Name
      </div>
      <div class="tr">
        <span>Titles</span>
        <span>{{form.title_language}}</span>
      </div>
      <div class="tr">
        <span>{{ [20,30].includes(form.enquiry_type)&&isFina?'Policyholder Name':'Name' }}</span>
        <span>{{form.name}}</span>
      </div>
      <div class="tr">
        <span>Mobile Number</span>
        <span>{{form.phone}}</span>
      </div>
      <div class="tr">
        <span>Email</span>
        <span>{{form.email}}</span>
      </div>
      <!--      <div class="tr">-->
      <!--        <span>Best Contact Time</span>-->
      <!--        <span>-->
      <!--          {{form.contact_dt_language}}<br>-->
      <!--          {{form.contact_time_id_language}}-->
      <!--        </span>-->
      <!--      </div>-->
      <div class="tr">
        <span>Additional Message</span>
        <span v-html="formatText(form.additional_msg)"></span>
      </div>
      <div
        v-if="![20,30,40].includes(form.enquiry_type)&&!isFina||isFina"
        class="tr">
        <span>I am the policyholder</span>
        <span>{{getOptionName('yesNoOptions',form.is_policy_holder)}}</span>
      </div>
    </div>
    <template   v-if="[20,30,40].includes(form.enquiry_type)">
      <div
        class="table">
        <div class="th">
          Information
        </div>
        <div
          v-if="[30].includes(form.enquiry_type)"
          class="tr">
          <span>Accident Date</span>
          <span>{{form.accident_date}}</span>
        </div>
        <div class="tr">
          <span>Contact Email</span>
          <span>{{form.email}}</span>
        </div>
        <div
          v-if="[30].includes(form.enquiry_type)&&isMotor"
          class="tr">
          <span>Involved Driver</span>
          <span>{{form.isrd_nm}}</span>
        </div>
        <div
          v-if="[30].includes(form.enquiry_type)&&isMotor"
          class="tr">
          <span>Involved Driver HKID</span>
          <span>{{form.id_no}}</span>
        </div>
        <div
          v-if="[30].includes(form.enquiry_type)&&!isMotor&&!isSme"
          class="tr">
          <span>Accident Insured</span>
          <span>{{form.isrd_nm}}</span>
        </div>
        <div
          v-if="[30].includes(form.enquiry_type)"
          class="tr">
          <span>Contact Person</span>
          <span>{{form.name}}</span>
        </div>
        <div class="tr">
          <span>Contact Number</span>
          <span>{{form.phone}}</span>
        </div>
        <div
          v-if="[30].includes(form.enquiry_type)"
          class="tr">
          <span>Brief Description Of The Accident</span>
          <span v-html="formatText(form.additional_msg)"></span>
        </div>
        <div
          v-else
          class="tr">
          <span>Additional Message</span>
          <span v-html="formatText(form.additional_msg)"></span>
        </div>

        <div class="tr">
          <span>Documents</span>
          <span>
            <span
              v-for="(item,index) in form.other_file"
              :key="index"
              class="blue pointer"
              @click="openUrl(item.url)">{{item.client_name}}</span>
          </span>
        </div>
      </div>
      <div
        v-if="isFina"
        class="table">
        <div class="th">
          Referrer
        </div>
        <div class="tr">
          <span>Referrer</span>
          <span>{{referrer.isrd_nm}}</span>
        </div>
        <div class="tr">
          <span>Referrer Number</span>
          <span>{{referrer.phone}}</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import MixinOptions from '@/mixins/options'
export default {
  name: 'enquiry-detail',
  mixins: [MixinOptions],
  props:{
    form:{
      type:Object,
      default:()=>({})
    }
  },
  computed:{
    isFina(){
      let {merchant_platform} = this.form||{}
      return merchant_platform==2
    },
    productId(){
      let {order_detail} = this.form||{}
      let {product_id} = order_detail||{}
      return  product_id||''
    },
    enquiry_type(){
      let {enquiry_type} = this.form||{}
      return enquiry_type
    },
    referrer(){
      let {referrer} = this.form||{}
      return referrer||{}
    },
    isMotor(){
      return this.productId == 11
    },
    isTravelOrPA(){
      let {type_of_insured} = this.form||{}
      return type_of_insured==2&&this.productId==18||[14].includes(this.productId)
    },
    isSme(){
      return this.productId == 80
    },
  },
  methods:{
    handleEidt(){
      this.$emit('edit')
    }
  }
}
</script>

<style scoped lang="scss">
.detail{
  .detail_title{
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    color: #24292E;
    margin-bottom: 20px;
  }

  .table {
    //border: 1px solid #E1E4E8;
    &.table_no_title{
      .tr:first-child{
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        border: 1px solid #E1E4E8;
      }
    }
    .table_tr_border0{
      .tr:last-child{
        border-radius: 0!important;
      }
    }
    .th{
      padding: 16px;
      background: $gray;
      border: 1px solid #E1E4E8;
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      color: $dark!important;
      font-weight: 600;
    }
    .tr {
      padding: 8px 16px;
      border: 1px solid #E1E4E8;
      border-top: 0;
      background: #fff!important;
      display: flex;
      align-items: center;

      /* Text/text-gray */

      color: #586069;
      &.tr-gray__title{
        background: $gray!important;
        span{
          color: #24292E!important;
        }
        .key-alt-down{
          color: #0366D6!important;
          cursor: pointer!important;
        }
      }
      span{
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #586069;
        &:nth-child(2){
          color: #24292E!important;
          &.key-alt-down{
            color: #0366D6!important;
            cursor: pointer!important;
          }
        }
      }
      .fw-600{
        font-weight: 600;
      }
      .top-algin{
        align-self: baseline;
      }
      .compare {
        display: flex;
        align-items: center;
        & > span {
          flex: 1;
        }
      }
      &:nth-child(2n){
        background: #fff;
      }
      &:last-child{
        //border: 0;
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
      }
    }
  }
}
</style>
